"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleHash = void 0;
const is_object_1 = __importDefault(require("./is-object"));
/**
 * Create a very simple (but stable) hash of any JS value. Stolen from
 * react-query. The result is good for comparison but should never be stored as
 * it may be very large (it's just a JSON representation of the data).
 */
const simpleHash = (data) => JSON.stringify(data, (_, val) => (0, is_object_1.default)(val)
    ? Object.entries(val).sort(([a], [b]) => (a < b ? 1 : b < a ? -1 : 0))
    : val);
exports.simpleHash = simpleHash;
